import httpAdapter, {
  ApiVersion,
  ContentType,
  HttpMethod,
} from "../../../utils/http-adapter";

const getPaymentLinkData = async ({ id }) =>
  await httpAdapter.request({
    method: HttpMethod.GET,
    apiVersion: ApiVersion.V1,
    path: `payment_links/${id}`,
    authneticated: false,
  });

const simulatePaymentSession = async ({
  postId,
  data: { pricingTierId, paymentLinkId, forceLKR = true },
}) => {
  return await httpAdapter.request({
    method: HttpMethod.POST,
    apiVersion: ApiVersion.V1,
    path: `account/posts/${postId}/checkout_tiered`,
    body: { pricingTierId, paymentLinkId, simulate: true, forceLKR },
    contentType: ContentType.FORM_URL_ENCODED,
  });
};

const simulatePaymentSessionWithPromoCode = async ({
  postId,
  data: { pricingTierId, paymentLinkId, forceLKR = true, promoCode },
}) => {
  return await httpAdapter.request({
    method: HttpMethod.POST,
    apiVersion: ApiVersion.V1,
    path: `account/posts/${postId}/checkout_tiered`,
    body: { pricingTierId, paymentLinkId, simulate: true, forceLKR, promoCode },
    contentType: ContentType.FORM_URL_ENCODED,
  });
};

const createCheckoutSession = async ({
  postId,
  data: {
    pricingTierId,
    paymentLinkId,
    paymentMethodId,
    forceLKR = true,
    promoCode,
  },
}) => {
  return await httpAdapter.request({
    method: HttpMethod.POST,
    apiVersion: ApiVersion.V1,
    path: `account/posts/${postId}/checkout_tiered`,
    body: {
      pricingTierId,
      paymentLinkId,
      paymentMethodId,
      forceLKR,
      simulate: false,
      ...(promoCode ? { promoCode } : {}),
    },
    contentType: ContentType.FORM_URL_ENCODED,
  });
};

const PaymentServiceAPI = {
  getPaymentLinkData,
  simulatePaymentSession,
  simulatePaymentSessionWithPromoCode,
  createCheckoutSession,
};

export default PaymentServiceAPI;
